module.exports = __webpack_public_path__ + "static/media/faceapp.1d46d41a.png";